module.exports = __webpack_public_path__ + "img/misa.d1365f61.png";